import React, { useEffect, useState } from 'react';

import { useQuizContext } from 'containers/Quiz/hooks/useQuizContext';

import './style.scss';
import StepPageViewWrapper from '../StepPageViewWrapper';

// colors: dark-body and secondary
const textColors = ['#2A1613', '#2A1613', '#2A1613', '#EDE1FD', '#EDE1FD'];

// custom colors transition to background
const backgroundColors = [
  '#DFD0CA',
  '#C5B3AB',
  '#AB958B',
  '#90766B',
  '#785A4D',
];

export const CountdownFromNumberToZero = ({ number, screenDuration }) => {
  const [count, setCount] = React.useState(number);
  const [colorIndex, setColorIndex] = useState(0);

  const timePerStep = screenDuration / number;

  useEffect(() => {
    const timer = setInterval(() => {
      if (count > 1) {
        setCount((prevCount) => prevCount - 1);
        setColorIndex((prevIndex) => (prevIndex + 1) % textColors.length);
      }
    }, timePerStep);

    return () => clearInterval(timer);
  }, [count, timePerStep]);

  useEffect(() => {
    document.body.style.backgroundColor = backgroundColors[colorIndex];

    return () => {
      document.body.style.backgroundColor = '';
    };
  }, [colorIndex]);

  return <p style={{ color: textColors[colorIndex] }}>{count}</p>;
};

interface IProps {
  trackingUrl: string;
}

const QuizCountdown = ({ trackingUrl }: IProps) => {
  const screenDuration = 4900;
  const count = 5;

  const { nextStep } = useQuizContext();

  useEffect(() => {
    const timer = setTimeout(() => {
      nextStep();
    }, screenDuration);

    return () => clearTimeout(timer);
  }, [screenDuration, nextStep]);

  return (
    <StepPageViewWrapper trackingUrl={trackingUrl}>
      <div className="QuizCountdown">
        <div className="countdown">
          <CountdownFromNumberToZero
            number={count}
            screenDuration={screenDuration}
          />
        </div>
      </div>
    </StepPageViewWrapper>
  );
};

export default QuizCountdown;
